import React from "react";
import {
  Link as RouterLink,
  Outlet as RouterOutlet,
  useLocation,
  useParams,
} from "react-router-dom";

export function createFileRoute(_path: string) {
  return (config: any) => ({
    ...config,
    useParams: () => useParams(),
  });
}

export function Link({ to, params, ...props }: any) {
  let target = String(to);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      target = target
        .replace(`$${key}`, encodeURIComponent(String(value)))
        .replace(`:${key}`, encodeURIComponent(String(value)));
    });
  }
  return <RouterLink to={target} {...props} />;
}

export const Outlet = RouterOutlet;
export function useRouterState({ select }: any = {}) {
  const location = useLocation();
  const state = { location };
  return select ? select(state) : state;
}

export function notFound() {
  return new Error("Not found");
}